module.exports = __webpack_public_path__ + "img/eng.7bd8598b.png";